import React, { DetailedHTMLProps,useEffect,useMemo, useState } from 'react'
import { BiInfoCircle } from 'react-icons/bi'
import CurrencyInput from 'react-currency-input-field'

export const MoneyInput = React.forwardRef<HTMLInputElement, Props>(({ label, important, necessary, info, ...props }, ref) => {

    const [value,setValue] = useState<string | undefined>(props.defaultValue? props.defaultValue : 0)

     const customValue = useMemo(()=>{
            if(!value) return 0.00
                return parseFloat(value)
     },[value])

     useEffect(()=>{

     })

    return (
        <div className=''>
            <label className='flex justify-between'>
                <div className='flex items-center'>
                    {label}
                    {important && <BiInfoCircle className='text-primary-dark ml-1' />}
                </div>
                {!necessary && <div className='text-sm italic '>opcional</div>}
            </label>
            <input hidden name={props.name} value={customValue} />
            <CurrencyInput 
                {...props}
                name="none"
                placeholder="R$ 0,00"
                prefix='R$ '
                value={value}
                decimalSeparator=","
                groupSeparator="."
                decimalsLimit={2}
                onValueChange={(value) => setValue(value) }
                className='className="w-full focus:outline-none h-10 border px-2' />
            <div className='text-gray-500 text-sm'>{info}</div>
            <div>

            </div>
        </div>
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {
    label: string,
    important?: boolean,
    necessary?: boolean
    info?: string
}
